"use client";
import cn from "clsx";
import { useState, useLayoutEffect } from "react";
import { getCookie, setCookie } from "@/util/cookies";
import * as Select from "@radix-ui/react-select";
import { Flex } from "@radix-ui/themes";
import Icon from "@/components/common/icon/icon";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });

export default function MenuButton({
  className,
  menuPosition,
  setMenuPostion,
}: {
  className?: string;
  menuPosition?: string;
  setMenuPostion?: Function;
}) {
  const [menu, setMenu] = useState(menuPosition ?? "");

  const menu_list: {
    [key: string]: {
      icon: string;
      value: string;
      className: string;
      selectClassName: string;
    };
  } = {
    L: {
      icon: "SquareHalf",
      value: "L",
      className: "rotate-180",
      selectClassName: "", //"hidden lg:block",
    },
    R: {
      icon: "SquareHalf",
      value: "R",
      className: "",
      selectClassName: "", //"hidden lg:block",
    },
    T: {
      icon: "SquareHalf",
      value: "T",
      className: "-rotate-90",
      selectClassName: "",
    },
    B: {
      icon: "SquareHalf",
      value: "B",
      className: "rotate-90 ",
      selectClassName: "",
    },
  };

  //값이 변경될때
  useLayoutEffect(() => {
    if (typeof window === "object" && document !== null) {
      const in_menu_str = getCookie("menu");
      if (menu === "" && in_menu_str != null) {
        
        setMenu(in_menu_str);
      } else {
        setCookie("menu", menu, 30, "/");
        if (menu !== in_menu_str) {
          switch (menu) {
            case "T":
              if (document.body.classList.contains("menuBottom")) {
                //document.body.classList.add("screenFull");
                document.body.classList.add("menuTop");
                setTimeout(function () {
                  document.body.classList.remove("menuBottom");
                  //document.body.classList.remove("screenFull");
                }, 150);
              } else {
                document.body.classList.add("menuTop");
                document.body.classList.remove("menuRight");
              }
              break;
            case "B":
              if (document.body.classList.contains("menuTop")) {
                //document.body.classList.add("screenFull");
                setTimeout(function () {
                  document.body.classList.remove("menuTop");
                  //document.body.classList.remove("screenFull");
                }, 150);
              }
              document.body.classList.remove("menuRight");
              document.body.classList.add("menuBottom");
              break;
            case "R":
              if (document.body.classList.contains("menuBottom")) {
                //document.body.classList.add("screenFull");
                setTimeout(function () {
                  document.body.classList.add("menuRight");
                  document.body.classList.remove("menuBottom");
                  //document.body.classList.remove("screenFull");
                }, 150);
              } else {
                document.body.classList.add("menuRight");
                document.body.classList.remove("menuTop");
              }
              break;
            default:
              if (document.body.classList.contains("menuBottom")) {
                //document.body.classList.add("screenFull");
                setTimeout(function () {
                  document.body.classList.remove("menuBottom");
                  //document.body.classList.remove("screenFull");
                }, 150);
              } else {
                document.body.classList.remove("menuRight");
                document.body.classList.remove("menuTop");
              }
              break;
          }
        }
        if (setMenuPostion && menuPosition !== menu) {
          setMenuPostion(menu);
        }
      }
    }
  }, [menu, menuPosition, setMenuPostion]);
  const rotate = menu_list[menu]?.className ?? "rotate-180";

  return (
    <Flex direction="column" className={cn(className, " menuButton")}>
      <Select.Root value={menu} onValueChange={setMenu} name="tool_menu_button">
        <Select.Trigger className="outline-0 group" id="tool_menu_button" aria-label="Tool Menu Button">
          <Flex id="themeState" align="center" gap="2" className="p-1 group-hover:animate-wiggle-more group-hover:animate-infinite">
            <Icon iconType="phosphor" iconName="SquareHalf" className={cn(rotate, "rotate" + menu, "w-5 h-5 transition-all rotat")} />
          </Flex>
        </Select.Trigger>
        <Select.Content position="popper">
          {Object.entries(menu_list).map(([key, value], index) => {
            return (
              <Select.Item
                value={key}
                key={"menuButtonSelect_" + index}
                className={cn(
                  menu == key ? "!hidden" : "",
                  value.selectClassName,
                  "cursor-pointer mt-1 p-1 outline-amber-500 group", // bg-[var(--color-background)]
                )}
              >
                <Icon iconType="phosphor" iconName={value.icon} className={cn(value.className, "w-5 h-5")} />
              </Select.Item>
            );
          })}
        </Select.Content>
      </Select.Root>
    </Flex>
  );
}
